import React from 'react';
import ChatInterface from './ChatInterface';
import { MODULE_TYPES } from '../../constants/chatModuleConfig';
import '../../styles/main.scss';

const DOCGeneration = () => {
    return (
        <div className="ibeam-container" style={{ padding: '16px', position: 'relative' }}>
            <ChatInterface moduleType={MODULE_TYPES.TECH_DOC} />
        </div>
    );
};

export default DOCGeneration;
